export const pipelineBoardKey = (pipelineId: string) => ['pipelineBoard', pipelineId] as const;
export const pipelineStagesKey = (pipelineId: string) => ['pipelineStages', pipelineId] as const;
export const pipelineTagsKey = (tenantId: number) => ['pipelineTags', tenantId] as const;
